import React from "react";
import Navbar from "../../component/Navbar";
import Footer from "../../component/Footer";
import FoodAndBeverage from "../../component/solutionscomponent/FoodAndBeverage";

const FoodBeverage = () => {
  return (
    <>
      <section className="usp_service_section">
        <Navbar />
        <FoodAndBeverage />
        <Footer />
      </section>
    </>
  );
};

export default FoodBeverage;
